
export function wrap(query, tag, cssclass = "") {
    for (const elem of query) {
        const newEl = document.createElement(tag);
        newEl.classList.add(cssclass);
        elem.parentElement.insertBefore(newEl, elem);
        newEl.appendChild(elem);
    }
}